import { Anchor, Button, Group, Image } from "@mantine/core";
import { Link } from "react-router-dom";
import logo from "../../assets/logo_rite_black.svg";
import { useContext } from "react";
import { store } from "../../store/store";
import { logout } from "../../_services";

const NavBar: React.FC = () => {
  const { state, dispatch } = useContext(store);
  return (
    <Group
      justify="space-between"
      align="flex-end"
      pt="md"
      pb="lg"
      mb="xl"
      style={{
        borderBottom: "1px solid var(--mantine-color-gray-4)",
        letterSpacing: "1.2px",
      }}
    >
      <Image src={logo} alt="" w={70} h="auto" />
      <Group justify="space-between" style={{ flex: 1, maxWidth: "80%" }} ml="xl">
        {state.loggedIn ? (
          <>
            <Group gap="lg">
              <Anchor
                component={Link}
                to="/"
                size="xl"
                tt="uppercase"
                c="dark.7"
              >
                Wizyty
              </Anchor>
              <Anchor
                component={Link}
                to="/offers"
                size="xl"
                tt="uppercase"
                c="dark.7"
              >
                Oferty
              </Anchor>
              <Anchor
                component={Link}
                to="/blog"
                size="xl"
                tt="uppercase"
                c="dark.7"
              >
                Blog
              </Anchor>
              <Anchor
                component={Link}
                to="/pages"
                size="xl"
                tt="uppercase"
                c="dark.7"
              >
                Strony
              </Anchor>
              <Anchor
                component={Link}
                to="/media"
                size="xl"
                tt="uppercase"
                c="dark.7"
              >
                Media
              </Anchor>
            </Group>
            <Button
              variant="subtle"
              color="gray"
              size="compact-sm"
              onClick={() => {
                dispatch({ type: "LOGOUT" });
                logout();
              }}
            >
              Wyloguj {state?.data?.name}
            </Button>
          </>
        ) : (
          <Anchor
            component={Link}
            to="/login"
            size="xl"
            tt="uppercase"
            c="dark.7"
          >
            Zaloguj
          </Anchor>
        )}
      </Group>
    </Group>
  );
};

export default NavBar;
